jQuery( ( $ ) => {
	'use strict';

	class LoadMorePosts {

		constructor( listElementSelector = '[data-blog-list]', btnSelector = '[data-load-more-posts]', paginationOptions = window.MLPosts ) {

			this.$itemsWrapper = $( listElementSelector );
			this.$btn = $( btnSelector );
			this.paginationOptions = paginationOptions || {};
			this.initEvents();

		}

		initEvents() {
			if ( this.$itemsWrapper.length && this.$btn.length ) {
				this.$btn.on( 'click', this.btnClickHandler.bind( this ) );
			}
		}


		btnClickHandler( event ) {

			event.preventDefault();
			const btnEl = event.currentTarget || event.target;

			if ( btnEl.classList.contains( 'loading' ) || !btnEl.classList.contains( 'active' ) ) {
				return;
			}

			this.loadMoreByBtn( btnEl );

		}

		/**
		 * Loads items by specified button element
		 * @param element
		 */
		loadMoreByBtn( element ) {

			const that = this;

			let $btn = $( element );

			$btn.addClass( 'loading' );

			that.paginationOptions.paged++;

			return $.ajax( {
				url: that.paginationOptions.ajaxurl,
				data: that.paginationOptions,
				type: 'POST',
				success: ( result ) => {
					if ( result && result.data && result.data.htmls && Array.isArray( result.data.htmls ) ) {

						result.data.htmls.forEach( ( html, index ) => {
							const $el = $( html );
							$el.addClass( 'wow fadeIn' );
							$el.appendTo( that.$itemsWrapper );
						} );

						if ( that.paginationOptions.paged >= result.data.max_num_pages ) {
							$btn.removeClass( 'active' );

						} else {
							$btn.addClass( 'active' );
						}

					}
					$btn.removeClass( 'loading' );
				},
				fail: ( err ) => {
					console.error( err );
					$btn.removeClass( 'active loading' );
				}
			} );
		}
	}

	// instantiate class
	new LoadMorePosts();


} );